import { ISettingsFormUseCase, IForm, FormType, IFormField } from "@lib";
import { ISettingsFormUpdateDto } from "@lib";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";

export class SettingsFormUseCase implements ISettingsFormUseCase {
    public async get(companyId: string, type: FormType): Promise<IForm | null> {
        try {
            const response = await Api.get<IForm | null>(`/companies/${companyId}/settings/forms/${type}`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async get2(companyId: string, type: FormType): Promise<{ form: IForm | null; fields: IFormField[] }> {
        try {
            const response = await Api.get<{ form: IForm | null; fields: IFormField[] }>(
                `/companies/${companyId}/settings/forms/${type}/v2`,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async update(companyId: string, type: FormType, dto: ISettingsFormUpdateDto): Promise<IForm> {
        try {
            const response = await Api.put<IForm>(`/companies/${companyId}/settings/forms/${type}`, dto);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
